import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../../environments/environment';
import {Comment} from './comment';

@Injectable()
export class CommentService {
    private static BASE = `${environment.api}/comments`;

    constructor(private http: HttpClient) {
    }

    fetchAll(): Observable<Comment[]> {
        return this.http.get<Comment[]>(CommentService.BASE);
    }

    add(newComment: Comment): Observable<Comment> {
        return this.http.post<Comment>(CommentService.BASE, newComment);
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/who-we-are/classes/comment.service.ts